
import {computed, ComputedRef, defineComponent, onMounted, Ref, ref, watch} from 'vue'
import {useStore} from 'vuex'
import {useI18n} from 'vue-i18n'
import {useRoute, useRouter} from 'vue-router'

import {message, Form} from 'ant-design-vue'

import {productExplainType} from '../../data'
import {StateType as HomeStateType} from '../../store'

interface ProductInfoData {
  destinationName: Ref<string>
  conData: any
}

export default defineComponent({
  name: 'productInfo',
  setup(props): ProductInfoData {
    const destinationName = ref<string>('')
    const store = useStore<{
      Home: HomeStateType
    }>()
    const route = useRoute()
    const router = useRouter()

    //获取地址
    const conData = computed<any[]>(() => store.state.Home.explainDataInfo)
    const getExplainTab = async (params: productExplainType) => {
      try {
        const res: boolean = await store.dispatch('Home/explainListFn', params)
      } catch (error) {
        message.warning('获取产品说明详情失败！')
      }
    }
    onMounted(() => {
      console.log(route.query.destinationName)
      destinationName.value = route.query.destinationName + ''
      const params = {
        productCode: route.query.value + '',
      }
      getExplainTab(params)
    })

    return {
      conData,
      destinationName,
    }
  },
})
